import {useRef} from 'react';
import {StyleSheet, View, Text} from 'react-native';
import {useDragDropTarget} from 'interface/hooks/useDragDropTarget';
import {DropFrame} from 'interface/base/DropFrame';
import {Link} from 'extensions/navigation/components/Link';
import {theme} from 'config/themes';
import {isTouch} from 'utils/platform';

export interface FolderBreadcrumbsItemProps {
  id: string;
  name: string;
  active?: boolean;
}

export function FolderBreadcrumbsItem(props: FolderBreadcrumbsItemProps) {
  const dndRef = useRef<View>(null);
  const hasTouch = isTouch();
  const isActive = props.active;
  const classes = {
    title: [
      styles.title,
      isActive && styles.active,
      hasTouch && styles.touchText,
    ]
  };

  const {isDropping} = useDragDropTarget({
    ref: dndRef,
    targetId: props.id,
    targetName: props.name,
  });

  return (
    <View ref={dndRef} style={styles.root}>
      <Link to={`/folder/${props.id}`}>
        <Text numberOfLines={1} style={classes.title}>
          {props.name}
        </Text>
      </Link>
      {isDropping && <DropFrame stroke="small"/>}
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    marginHorizontal: 2,
  },
  touchText: {
    fontSize: 14,
  },
  link: {
    marginHorizontal: 8,
  },
  title: {
    fontSize: 12,
    lineHeight: 32,
    paddingHorizontal: 8,
    color: theme.files.breadcrumbs.text,
  },
  active: {
    opacity: 1,
  },
});
